import { isFunction, isObject, isArray } from "../utils"

const VIDEO_SECTION_KEYS = [
  {
    key: 'title',
    control: 'text',
    translatable: true,
  },
  {
    key: 'content',
    control: 'text',
    translatable: true
  }
]

const GALLERY_LIST_DEFINITION = {
  control: 'object',
  description: 'An object that contains the image and the caption of each item in the gallery',
  keys: [
    {
      key: 'image_source',
      control: 'image'
    },
    {
      key: 'caption',
      control: 'text',
      translatable: true,
    }
  ]
}

const GALLERY_SECTION_KEYS = [
  {
    key: 'gallery',
    control: 'list',
    description: 'A gallery of images with captions',
    children_title_key: 'caption',
    items: GALLERY_LIST_DEFINITION,
    create: {
      templates: [
        {
          title: 'Sample Image',
          description: 'A sample image with a caption',
          image: '/images/previews/blank.webp',
          value: {
            image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image1.webp',
            caption: 'Sample caption'
          }
        }
      ]
    }
  }
]

const IMAGE_CONTRAST_SECTION_KEYS = [
  {
    key: 'fit_screen',
    control: 'switch'
  },
  {
    key: 'title',
    control: 'text',
    translatable: true,
  },
  {
    key: 'content',
    control: 'text',
    translatable: true,
  },
  {
    key: 'image_source',
    control: 'image',
  },
  {
    key: 'image_fit',
    control: 'text',
  },
]

const CONTENT_SECTION_KEYS = [
  {
    key: 'content',
    control: 'text',
    translatable: true,
  }
]

const IMAGE_INTERACTIVE_SECTION_KEYS = [
  {
    key: 'content',
    control: 'text',
    translatable: true,
  },
  {
    key: 'instructions',
    control: 'text',
    translatable: true,
  },
  {
    key: 'img',
    control: 'image',
  },
  {
    key: 'max_width',
    control: 'text',
  },
]

const SECTION_DEFINITION = {
  control: 'object',
  description: 'Una página se compone de una o más secciones como este.',
  editor: (data) => ((data.type === 'progressive-image-interactive-section' || data.type === 'maquette-section') && 'interactive-map-editor'),
  keys: [
    {
      key: 'type',
      control: 'text', // select
      options: ['content-section', 'video-section'],
      required: true
    },
    {
      key: 'fit_screen',
      control: 'switch'
    },
    {
      key: 'alternative_background',
      control: 'switch'
    },
    (data) => (data.type === 'video-section') && VIDEO_SECTION_KEYS,
    (data) => (data.type === 'content-section') && CONTENT_SECTION_KEYS,
    (data) => (data.type === 'gallery-section') && GALLERY_SECTION_KEYS,
    (data) => (data.type === 'image-contrast-section') && IMAGE_CONTRAST_SECTION_KEYS,
    (data) => (data.type === 'image-interactive-section') && IMAGE_INTERACTIVE_SECTION_KEYS
  ]
}

const PAGE_DEFINITION = {
  control: 'object',
  description: 'Un sitio web se compone de muchas páginas como esta.',
  keys: [
    {
      key: 'slug',
      control: 'text',
      placeholder: '/mi-pagina',
      description: 'Se usa para definir cual url se asignará a esta página.',
      required: true,
      translatable: true,
    },
    {
      key: 'menu_item',
      control: 'text',
      placeholder: 'Mi Página',
      description: 'Si esta definido, aparecerá una entrada en el menú principal con este valor.',
      translatable: true,
    },
    {
      key: 'menu_highlight',
      control: 'switch',
      description: 'Resalta esta entrada en el menú principal'
    },
    {
      key: 'sections',
      control: 'list',
      children_title_key: 'type',
      items: SECTION_DEFINITION,
      create: {
        templates: [
          {
            title: 'Two Columns',
            description: 'An image gallery with text separated in two columns',
            image: '/images/previews/two-columns.png',
            value: {
              className: 'icon-bullets',
              fit_screen: true,
              alternative_background: true,
              type: 'gallery-section',
              content: `# Ipsum Lorem
                        || [:star:] || Lorem Ipsum.
                        || [:monitor:] || Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit duis tristique sollicitudin nibh. Nibh sit amet commodo nulla facilisi nullam vehicula ipsum a. Condimentum id venenatis a condimentum vitae sapien. Vestibulum morbi blandit cursus risus at ultrices mi tempus.`,
              gallery: [
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image1.webp',
                  caption: 'Lorem',
                },
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image2.webp',
                  caption: 'Ipsum',
                },
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image3.webp',
                  caption: 'Consectetur',
                },
              ],
            }
          },
          {
            title: 'Two Columns with CTA',
            description: 'An image gallery with text + CTA button, separated in two columns',
            image: '/images/previews/two-columns-with-CTA.png',
            value: {
              className: 'icon-bullets',
              fit_screen: true,
              alternative_background: true,
              type: 'gallery-section',
              content: `# Ipsum Lorem
                        || [:star:] || Lorem Ipsum.
                        || [:monitor:] || Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit duis tristique sollicitudin nibh. Nibh sit amet commodo nulla facilisi nullam vehicula ipsum a. Condimentum id venenatis a condimentum vitae sapien. Vestibulum morbi blandit cursus risus at ultrices mi tempus.`,
              gallery: [
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image1.webp',
                  caption: 'Lorem',
                },
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image2.webp',
                  caption: 'Ipsum',
                },
                {
                  image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image3.webp',
                  caption: 'Consectetur',
                },
              ],
              call_to_action: {
                label: 'Lorem Ipsum',
                href: '/',
              },
            }
          },
          {
            title: 'Banner 3 Steps',
            description: 'A full-width banner that allows user to choose, quote and reserve',
            image: '/images/previews/banner-3-steps.png',
            value: {
              type: 'info-grid-section',
              fit_screen: true,
              className: 'center-content-section',
              id: 'flow-page',
              alternative_background: true,
              grid: {
                template: '1fr',
                desktop_template: '1fr',
                grid: [
                  {
                    type: 'column',
                    className: 'center-column-content width-fit-content',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '# Lorem ipsum dolor sit amet\nUt enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
                      },
                      {
                        type: 'column',
                        template: '1fr',
                        desktop_template: '1fr',
                        className: 'icon-bullets width-fit-content',
                        rows: [
                          {
                            type: 'paragraph',
                            content: '||[:hand:]||**Lorem** ipsum dolor sit amet',
                          },
                          {
                            type: 'paragraph',
                            content: '||[:cotizacion:]||**Ipsum** laboris nisi ut aliquip ex ea commodo',
                          },
                          {
                            type: 'paragraph',
                            content: '||[:check-circle:]||**Excepteur sint**',
                          },
                        ],
                      },
                      {
                        type: 'paragraph',
                        content: '¡Excepteur sint occaecat cupidatat non proident!',
                      },
                    ],
                  },
                ],
              }
            }
          },
          {
            title: 'Banner 3 Steps with CTA',
            description: 'A full-width banner that allows user to choose, quote and reserve with a CTA button',
            image: '/images/previews/banner-3-steps-with-CTA.png',
            value: {
              type: 'info-grid-section',
              fit_screen: true,
              className: 'center-content-section',
              alternative_background: true,
              grid: {
                template: '1fr',
                desktop_template: '1fr',
                grid: [
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '# Lorem ipsum dolor sit amet ut enim ad minim veniam',
                      },
                      {
                        type: 'grid',
                        template: '1fr',
                        desktop_template: '1fr 1fr',
                        grid: [
                          {
                            type: 'column',
                            className: 'icon-bullets',
                            rows: [
                              {
                                type: 'paragraph',
                                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
                              },
                              {
                                type: 'paragraph',
                                content: '||[:hand:]||**Lorem ipsum dolor**',
                              },
                              {
                                type: 'paragraph',
                                content: '||[:cotizacion:]||**Ut enim ad minim veniam**',
                              },
                              {
                                type: 'paragraph',
                                content: '||[:check-circle:]||**Excepteur sint**',
                              },
                              {
                                type: 'paragraph',
                                content: '¡Sunt in culpa qui officia deserunt mollit anim id est laborum!',
                              },
                            ],
                          },
                          {
                            type: 'column',
                            rows: [
                              {
                                type: 'paragraph',
                                content: '**¿Lorem ipsum dolor?**\n¡Duis aute!  Excepteur sint occaecat cupidatat non proident',
                              },
                              {
                                type: 'call-to-action',
                                label: 'Lorem ipsum [:arrow_right:]',
                                href: '/',
                                justify_content: 'space-between'
                              },
                            ]
                          },
                        ]
                      },
                    ],
                  },
                ],
              }
            }
          },
          {
            title: 'Typologies cards',
            description: 'A card gallery of typologies',
            image: '/images/previews/typologies-cards.png',
            value: {
              type: 'card-gallery-section',
              content: '### Fecha de entrega: Septiembre 2023',
              alternative_background: true,
              cards: 'typologies',
              data: {
                builder_typology: 'custom_data.typologies[card]',
                typology: 'typologies[card]'
              },
              href: '/tipologia/{{typology.typology}}',
              card_template: {
                template: '1fr',
                desktop_template: '1fr',
                grid: [
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'image',
                        width: '100%',
                        height: '240px',
                        object_fit: 'cover',
                        image_source: '{{builder_typology.cover_image}}',
                      },
                      {
                        type: 'column',
                        padding: '16px',
                        grow: true,
                        rows: [
                          {
                            type: 'paragraph',
                            content:
                              '###[.bold] Tipología {{card}}\n### $ {{builder_typology.price_from | currency}}\n{{builder_typology.description}}',
                          },
                          {
                            type: 'row',
                            spacing: '8px',
                            columns: [
                              {
                                type: 'text',
                                content: '[:bed:] {{typology.bedrooms.from}}',
                              },
                              {
                                type: 'text',
                                content: '[:shower:] {{typology.bathrooms.from}}',
                              },
                              {
                                type: 'text',
                                content: '[:plane:] {{typology.construction_size.from}}',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            },
          },
          {
            title: 'Media with Text',
            description: 'A place to put a video with a text description',
            image: '/images/previews/media-with-text.png',
            value: {
              type: 'video-section',
              fit_screen: true,
              alternative_background: true,
              title: 'Lorem ipsum dolor sit amet',
              video_source: '/videos/amaia.mp4',
              poster_source: '/img/rostro-urbano-poster.webp',
              content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
            }
          },
          {
            title: 'Media',
            description: 'A full-width section to put a video',
            image: '/images/previews/media.png',
            value: {
              type: 'content-section',
              className: 'background-image',
              id: 'home_video',
              content: '![/img/rostro-urbano-poster.webp](video:/videos/amaia.mp4)',
            }
          },
          {
            title: 'Alohome verified with CTA',
            description: 'A full-width verified by Alohome banner with a CTA button',
            image: '/images/previews/alohome-verified-with-CTA.png',
            value: {
              type: 'info-note-section',
              id: 'verified_development',
              fit_screen: true,
              background: 'url(https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image2.webp)',
              note: {
                content:
                  '[:alohome_verificado:] Alohome ha verificado la información de **Proyecto** (trámites, permisos y avance de la construcción) para asegurar la transparencia y garantía del proyecto.',
                call_to_action: {
                  label: 'Ver avance del proyecto [:arrow_right:]',
                  href: '/',
                  justify_content: 'space-between',
                },
              },
            }
          },
          {
            title: 'Alohome verified',
            description: 'A full-width verified by Alohome banner',
            image: '/images/previews/alohome-verified.png',
            value: {
              type: 'info-note-section',
              id: 'verified_development',
              fit_screen: true,
              background: 'url(https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image2.webp)',
              note: {
                content:
                  '[:alohome_verificado:] Alohome ha verificado la información de **Proyecto** (trámites, permisos y avance de la construcción) para asegurar la transparencia y garantía del proyecto.',
              },
            }
          },
          {
            title: 'Banner with features list',
            description: 'A banner with a list of features (icon + text)',
            image: '/images/previews/banner-with-features.png',
            value: {
              type: 'info-grid-section',
              id: 'turism-places',
              grid: {
                template: '1fr',
                desktop_template: '1fr',
                grid: [
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '# Lorem ipsum dolor',
                      },
                      {
                        type: 'grid',
                        template: '1fr',
                        desktop_template: '1fr 1fr',
                        grid: [
                          {
                            type: 'paragraph',
                            content: '||[:star:]|| Ut enim ad minim veniam'
                          },
                          {
                            type: 'paragraph',
                            content: '||[:umbrella:]|| Excepteur sint occaecat'
                          },
                          {
                            type: 'paragraph',
                            content: '||[:dollar:]|| Fugiat nulla pariatur'
                          },
                          {
                            type: 'paragraph',
                            content: '||[:airbnb:]|| Laboris nisi ut aliquip ex ea commodo consequat'
                          },
                          {
                            type: 'paragraph',
                            content: '||[:star:]|| Voluptate velit esse'
                          },
                          {
                            type: 'paragraph',
                            content: '||[:umbrella:]|| Exercitation ullamco laboris',
                          }
                        ],
                      },
                    ],
                  },
                ],
              }
            }
          },
          {
            title: 'Banner with CTA',
            description: 'A banner with a centered CTA button',
            image: '/images/previews/banner-with-CTA.png',
            value: {
              type: 'content-section',
              alternative_background: true,
              className: 'center-content-section center-column-content',
              content: '# ¿Excepteur sint occaecat cupidatat?\n Non proident!, sunt in culpa qui officia deserunt mollit',
              call_to_action: {
                label: 'Duis aute irure',
                href: '/',
              },
            }
          },
          {
            title: 'Banner with choose unit',
            description: 'A banner with a centered CTA button and dropdown to change unit',
            image: '/images/previews/banner-with-choose-unit.png',
            value: {
              type: 'info-grid-section',
              id: 'typology-details',
              alternative_background: true,
              grid: {
                template: '1fr',
                desktop_template: '1fr',
                grid: [
                  {
                    type: 'grid',
                    template: ' 1fr',
                    desktop_template: '1fr',
                    grid: [
                      {
                        type: 'column',
                        className: 'center-content-section center-column-content',
                        rows: [
                          {
                            type: 'selector',
                            className: 'details-table__column details-table__column_selector',
                            description: '###[.details-table__column_title] Elige tu ubicación dentro de la torre\nDecide en qué piso quieres tener tu apartamento',
                            dropdown: {
                              data_source: '{{ units | filter(typology == fetched_category.typology) | filter(status == "available") | order(by:"fields.floor", direction:"desc") }}',
                              placeholder: 'Seleccione un Piso',
                              left_label: 'Piso {{ option.fields.floor }}',
                              right_label: '$ {{option.price.price | currency}}',
                              selected_label: 'Piso {{}}'
                            },
                            call_to_action: {
                              label: 'Ver departamento',
                              href: '/unidades/{{option.unit_id}}',
                            }
                          },
                        ],
                      },
                    ]
                  }
                ],
              },
            }
          },
          {
            title: 'Features with ROI',
            description: 'Section with unit\'s features and its return of investment',
            image: '/images/previews/features-with-ROI.png',
            value: {
              type: 'info-grid-section',
              grid: {
                template: '1fr',
                desktop_template: '3fr 2fr',
                grid: [
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '## Detalles\nPrecio: $ {{unit.price.price | currency}}',
                      },
                      {
                        type: 'grid',
                        template: 'minmax(auto, 1fr) minmax(auto, 1fr)',
                        desktop_template:
                          'minmax(auto, 1fr) minmax(auto, 1fr) minmax(auto, 1fr)',
                        grid: [
                          {
                            type: 'paragraph',
                            content: '|- [:plane:] || **{{unit.fields.interior_m2}}**  == m^^2^^ interiores:',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:plane:] || **{{unit.fields.exterior_m2}}** == m^^2^^ exteriores',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:studio:] || **{{unit.fields.studyroom}}** == Estudios',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:bed:] || **{{unit.fields.bedrooms}}** == Habitaciones',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:shower:] || **{{unit.fields.bathrooms}}** == Baños',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:roof_garden:] || **{{unit.fields.Terrace}}** == Terrazas',
                          },
                          {
                            type: 'paragraph',
                            content: '|- [:car:] || **{{unit.fields.parkinglots}}** == Estacionamientos',
                          },
                        ],
                      },
                      {
                        type: 'grid',
                        template: 'minmax(auto, 1fr)',
                        desktop_template:
                          'minmax(auto, 1fr) minmax(auto, 1fr)',
                        grid: [
                          {
                            type: 'paragraph',
                            content: "|- Fecha de entrega: == **{{unit.delivery_date | date(month:'long', year:'numeric') | capitalize}}**",
                          },
                          {
                            type: 'paragraph',
                            content: '|- Estado de la propiedad: == **19% completada**',
                          },
                        ]
                      }
                    ],
                  },
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '## Proyección de rentabilidad',
                      },
                      {
                        type: 'text',
                        content:
                          'Actualizado  {{custom_data.typologies[unit.typology].investment.updated}}',
                      },
                      {
                        type: 'grid',
                        template: '100%',
                        desktop_template: 'minmax(auto, 1fr) minmax(auto, 1fr)',
                        grid: [
                          {
                            type: 'paragraph',
                            content:
                              '|- [:dollar:] || Renta mensual: == **{{custom_data.typologies[unit.typology].investment.monthly_lease}}**',
                          },
                          {
                            type: 'paragraph',
                            content:
                              '|- [:roi:] || Renta retorno anual: == **{{custom_data.typologies[unit.typology].investment.anually_roi}}**',
                          },
                          {
                            type: 'paragraph',
                            content:
                              '|- [:airbnb:] || Airbnb por noche: == **{{custom_data.typologies[unit.typology].investment.airbnb_night}}**',
                          },
                          {
                            type: 'paragraph',
                            content:
                              '|- [:airbnb_roi:] || Airbnb retorno anual: == **{{custom_data.typologies[unit.typology].investment.airbnb_anually}}**',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            }
          },
          {
            title: 'Features with CTA',
            description: 'Section with unit\'s features and a button to change unit',
            image: '/images/previews/features-with-CTA.png',
            value: {
              type: 'info-grid-section',
              id: 'unit-details',
              grid: {
                template: '1fr',
                desktop_template: '1fr 1fr',
                grid: [
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'paragraph',
                        content: '### Detalles\nPrecio: **desde ${{unit.price.price | currency}}**',
                      },
                      {
                        type: 'grid',
                        template: 'minmax(auto, 1fr) minmax(auto, 1fr)',
                        desktop_template: 'repeat(3, minmax(auto, 33%))',
                        grid: [
                          {
                            type: 'paragraph',
                            content: '|-[:plane:]||**{{unit.fields.areaConstruida}} m^^2^^**==área construida',
                          },
                          {
                            type: 'paragraph',
                            content: '|-[:plane:]||**{{unit.fields.areaPrivada}} m^^2^^**==área privada',
                          },
                          {
                            type: 'paragraph',
                            content: '|-[:bed:]||**{{unit.fields.cantidadAlcobas}}**==Alcobas',
                          },
                          {
                            type: 'paragraph',
                            content: '|-[:shower:]||**{{unit.fields.bathrooms}}**==W.C.',
                          },
                        ],
                      },
                      {
                        type: 'grid',
                        template: 'minmax(auto, 50%) minmax(auto, 50%)',
                        desktop_template: 'repeat(2, minmax(auto, 25rem))',
                        grid: [
                          {
                            type: 'paragraph',
                            content: ' Fecha de entrega:\n **{{unit.delivery_date | date(month:"long", year:"numeric") | capitalize}}**',
                          },
                          {
                            type: 'paragraph',
                            content: 'Estado de la propiedad:\n **{{custom_data.status_labels[unit.status].label}}**',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    type: 'column',
                    rows: [
                      {
                        type: 'selector',
                        description: '### Elige tu piso dentro de la torre\nPuedes mantener la ubicación actual o cambiarla',
                        dropdown: {
                          data_source: '{{ units | filter(typology == unit.typology) | filter(status == "available") | order(by:"fields.floor", direction:"desc") }}',
                          placeholder: 'Seleccione un Piso',
                          left_label: 'Piso {{ option.fields.floor }} ({{ option.fields.alterName }})',
                          right_label: '$ {{option.price.price | currency}}',
                          selected_label: 'Piso {{}}'
                        },
                        call_to_action: {
                          label: 'Ver apartamento',
                          href: '/unidades/{{option.unit_id}}',
                        }
                      },
                    ],
                  },
                ],
              },
            }
          },
          {
            title: 'Best Result',
            description: 'Section that shows the best result of find your depa',
            image: '/images/previews/best-result.png',
            value: {
              type: 'apartment-results-section',
              content: '#[.apartment-results-title] Encontramos este departamento para ti.\n¡Gracias por contarnos cómo sería tu depa ideal! Evaluamos varias opciones y esta es la que mejor se adapta a lo que estás buscando.',
              amenities_content: {
                amenities_text: '**Además podrás disfrutar de todas las amenidades**',
                amenities_list: [
                  '[:grill:] Área de asadores',
                  '[:pool:] Alberca',
                  '[:coffee:] Área social',
                  '[:clover:] Áreas verdes',
                  '[:dog:] Áreas de mascotas',
                  '[:shield:] Seguridad 24/7',
                  '[:happy:] Áreas de niños',
                ]
              },
              try_again_content: {
                try_again_text: '¿No es lo que esperabas? ¡Tenemos más opciones! Realiza de nuevo el cuestionario o conoce los otros departamentos disponibles que te mostramos abajo',
                call_to_action: {
                  label: 'Probar de nuevo',
                  href: '/busca-tu-departamento',
                }
              },
              other_results_content: '### También te pueden interesar estos departamentos:',
              unit_slug: '/unidades',
              unit_card: {
                apartment_label: 'Departamento {{unit.department_number}}',
                type_label: ''
              }
            }
          },
          {
            title: 'Best Result Simple with CTA',
            description: 'Section that shows the best result with a CTA button',
            image: '/images/previews/best-result-CTA.png',
            value: {
              type: 'apartment-results-section',
              content: '# Encontramos este apartamento para ti.\n¡Gracias por contarnos cómo sería tu apartamento ideal! Evaluamos varias opciones y esta es la que mejor se adapta a lo que estás buscando.',
              call_to_action: {
                label: 'Cotizar',
                href: '/cotiza-tu-departamento',
              },
              other_results_content: '### También te pueden interesar estos departamentos:',
              unit_slug: '/unidades',
              unit_card: {
                apartment_label: 'Departamento {{unit.department_number}}',
                type_label: 'Tipo {{typology}}',
                footer_badge_label: '',
              }
            }
          },
          {
            title: 'Location Map',
            description: 'Shows a Google maps section centered at project\'s position',
            image: '/images/previews/location-map.png',
            value: {
              type: 'map-section',
              fit_screen: true,
              coordinates: {
                latitude: 25.6674691,
                longitude: -100.4586917,
              },
              overlay: {
                image_source: '/assets/9352d3a0-61b0-11ec-9fca-9b51a42dc754',
                content:
                  '### Lorem ipsum\n ENIM Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
                call_to_action: {
                  label: 'Excepteur sint',
                  href: '/',
                },
              },
            }
          },
          {
            title: 'Header Developer',
            description: 'Header section to show developer\'s information',
            image: '/images/previews/header-developer.png',
            value: {
              type: 'image-contrast-section',
              className: 'logos-table',
              id: 'seccion-desarrollador',
              fit_screen: true,
              content: '# Architectural solutions for a better world\n![MIKA](https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image1.webp)\nEn MIKA creamos conceptos innovadores y adaptados de forma respetuosa con el entorno, ofreciendo servicios integrales de arquitectura y construcción de manera funcional, estética y responsable.\nNos centramos en brindar a nuestros clientes oportunidades de inversión rentables y exitosas con un diseño destacable, único y reconocido.',
              image_source: 'https://alohome-assets.s3.amazonaws.com/site-builder/gallery-image1.webp',
            }
          },
          {
            title: 'Project Progress Hero',
            description: 'Hero of Project Progress page with Alohome verified logo',
            image: '/images/previews/project-progress.png',
            value: {
              type: 'trust-report-section',
              alternative_background: true,
              header_title: 'Avance de obra',
              header_description:
                'Para proporcionarle mayor transparencia e información, Alo Home trabaja con los Desarrolladores del Proyecto para obtener más información respecto al Proyecto, los Trámites de Permisos y el Avance de Construcción.',
              header_cta: {
                description: '¿Tienes alguna pregunta o quieres saber más?',
                button_label: 'Hablar con un asesor',
              },
              header_image_source: '/assets/468d7280-9993-11ec-abe8-61d58ac5bbd9',
              header_image_alt: 'Alohome logo',
            }
          },
          {
            title: 'Construction Progress Blog',
            description: 'Details of the construction progress segmented by month',
            image: '/images/previews/construction-progress.png',
            value: {
              type: 'construction-progress-section',
              header_label: 'Selecciona un periodo para ver el avance',
              date_modified_label: 'Actualizado el',
              periods: [
                {
                  period_label: 'Periodo Diciembre',
                  date_modified: '2021-12-15',
                  sections: [
                    {
                      type: 'progress-section',
                      title: 'Construcción',
                      value: 19,
                      flex_basis: 33,
                      steps: [
                        '|| [:checked:] || Por iniciar obra',
                        '|| [:unchecked:] || Excavación',
                        '|| [:unchecked:] || Estructura',
                        '|| [:unchecked:] || Albañilerias',
                        '|| [:unchecked:] || Instalaciones - acabados',
                      ],
                    },
                    {
                      type: 'image-carousel-section',
                      title: 'Galería del periodo actual',
                      gallery: [
                        {
                          src: '/assets/b5058680-5ac8-11ec-9fca-9b51a42dc754',
                          label: '14 de octubre 2021',
                        },
                        {
                          src: '/assets/bdedcc80-5ac8-11ec-9fca-9b51a42dc754',
                          label: '14 de octubre 2021',
                        },
                        {
                          src: '/assets/d7eb8be0-5ac8-11ec-9fca-9b51a42dc754',
                          label: '30 de agosto 2021',
                        },
                        {
                          src: '/assets/df8e0b70-5ac8-11ec-9fca-9b51a42dc754',
                          label: '30 de agosto 2021',
                        },
                      ],
                    },
                    {
                      type: 'progress-section',
                      title: 'Resumen del proyecto',
                      flex_basis: 50,
                      steps: [
                        '|| [:checked:] || El Desarrollador ha proporcionado prueba de la propiedad de la tierra.',
                        '|| [:checked:] || El Desarrollador ha proporcionado copias de los permisos existentes para la Fase I.',
                        '|| [:checked:] || El Desarrollador ha proporcionado proyecto arquitectonico y estructural para las Fase I.',
                        '|| [:checked:] || Alohome ha verificado que toda la información coincide.',
                      ],
                    },
                    {
                      type: 'progress-section',
                      title: 'Permisos',
                      value: 75,
                      flex_basis: 50,
                      steps: [
                        ' **Uso de suelo**\n|| [:checked:] || El uso de suelo indica el número de niveles, la altura máxima y el porcentaje de área libre que se tiene que respetar.',
                        ' **Factibilidades de servicios**\n|| [:checked:] || Indica la disponibilidad de servicios de energía eléctrica, agua potable, y drenaje para el proyecto.',
                        ' **Impactos urbano/ambiental**\n|| [:checked:] || Dependiendo de la escala del proyecto, autoriza las medidas de mitigación al tráfico y al medio ambiente.',
                        ' **Manifestación de construcción**\n|| [:unchecked:] || Autoriza la construcción del proyecto presentado en cumplimiento a toda la normativa.'
                      ],
                    },
                    {
                      type: 'progress-section',
                      title: 'Probabilidad de cambios y retrasos',
                      value: 20,
                      flex_basis: 100,
                      steps: [
                        'El Proyecto arquitectónico y estructural se encuentran completos. Se encuentra en tramite la manifestación de construcción de la primera fase en el municipio. Aún existe probabilidad de cambios en el proyecto resultando de la excavación/cimentación.'
                      ]
                    }
                  ],
                },
              ],
            }
          },
        ]
      }
    }
  ]
}

const GENERAL_DEFINITION = {
  control: 'object',
  description: 'Configuración general del sitio web.',
  keys: [
    {
      key: 'pages',
      control: 'object',
      children_title_key: 'slug',
      items: PAGE_DEFINITION,
      create: {
        templates: [
          {
            title: 'Blank Page',
            description: 'A blank page',
            image: '/images/previews/blank.webp',
            value: {
              slug: '/sample_page',
              menu_item: 'Sample Page',
              sections: []
            }
          }
        ]
      }
    }
  ],
}

const flattenKeys = (keys, data) => {
  return keys.reduce((memo, entry) => {
    if (isFunction(entry)) {
      const result = entry(data)
      if (!result) {
        /* Nothing to do */
      } else if (isObject(result)) {
        if (!result.key) throw new Error('Object item without key')
        memo[result.key] = result
      } else if (isArray(result)) {
        const newKeys = flattenKeys(result, data)
        Object.assign(memo, newKeys)
      } else if (isArray(result)) {
        throw new Error('Invalid keys definition')
      }
    } else if (isObject(entry)) {
      if (!entry.key) throw new Error('Object item without key')
      memo[entry.key] = entry
    } else {
      throw new Error('Invalid definition structure')
    }
    return memo
  }, {})
}

export { GENERAL_DEFINITION, flattenKeys }